
export const MiddleForm=()=>{

    return(
        <div className="middle-form __container">
            <div className="middle-form_header">
                <h1>Want to know more? Ask us a question:</h1>
            </div>
            <div className="middle-form_form-placeholder">
                <div className="middle-form_form_block">
                    <p>Name</p>
                    <input placeholder="Your name"/>
                </div>
                <div className="middle-form_form_block">
                    <p>Phone</p>
                    <input placeholder="Your phone"/>
                </div>
                <div className="middle-form_form_block wider-input">
                    <p>Message</p>
                    <input placeholder="Your message"/>
                </div>
                <button>
                    Send
                </button>
            </div>
        </div>
    )
}